import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinusMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMinusMedium"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 12C4.5 11.4477 4.8731 11 5.33333 11H18.6667C19.1269 11 19.5 11.4477 19.5 12C19.5 12.5523 19.1269 13 18.6667 13H5.33333C4.8731 13 4.5 12.5523 4.5 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinusMedium;
